import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const ROWS = [
  ["Work today", "area"], ["Industry", "industry"], ["AI goal", "goal"], ["Problem to explore", "problem_idea"],
  ["Most advanced AI work", "experience"], ["Main blocker", "blocker"], ["Weekly time", "hours"], ["First 7-day result", "first_result"],
];

export const LeadDetail = ({ lead, onClose }) => (
  <Dialog open={Boolean(lead)} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="admin-lead-detail" className="max-h-[90vh] max-w-xl overflow-y-auto">
      {lead && (
        <>
          <DialogTitle className="font-display text-[22px] text-[#0B1B33]">{lead.name}</DialogTitle>
          <DialogDescription>{lead.email}{lead.phone ? ` · ${lead.phone}` : ""} · Marketing consent: {lead.consent_marketing ? "Yes" : "No"}</DialogDescription>
          <div className="rounded-lg bg-teal-50 p-3 text-[14px]"><b>{lead.route_name}:</b> {lead.headline}{lead.course_name && <><br /><b>Suggested course:</b> {lead.course_name} ({lead.course_fee})</>}</div>
          <dl className="space-y-2 text-[14px]">
            {ROWS.map(([k, f]) => (
              <div key={f}><dt className="text-[12px] font-semibold uppercase tracking-wide text-slate-500">{k}</dt><dd className="text-slate-800">{lead.answers?.[f] || "-"}</dd></div>
            ))}
          </dl>
          {(lead.notes || []).map((n) => <p key={n} className="text-[13px] text-slate-600">Note: {n}</p>)}
        </>
      )}
    </DialogContent>
  </Dialog>
);
